import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "4px",
  },
}));
